<div class="card">
    <div class="card-body card-header-border">
        <div *ngIf="pending">
            <cmps-wait-status></cmps-wait-status>
        </div>
        <cmps-tabset
            *ngIf="!pending"
            (selectedTabRefIdChange)="_handleTabChange($event)"
        >
            <cmps-tabset-label-wrapper class="mb-3">
                <ng-template
                    cmpsTabLabel
                    [tabRefId]="_NavigationTabRefs.ACTIVE_FOR_PERFORMER"
                    let-ctx
                >
                    <button
                        cmpsTabButton
                        theme="a"
                        [selected]="ctx.selected"
                        (click)="ctx.select()"
                    >
                        <span cmpsTabButtonLabel>{{
                            _i18n._11095_ACTIVE_FOR_THIS_PERFORMER | translate
                        }}</span>
                    </button>
                </ng-template>
                <ng-template
                    cmpsTabLabel
                    [tabRefId]="
                        _NavigationTabRefs.RECENTLY_CLOSED_FOR_PERFORMER
                    "
                    let-ctx
                >
                    <button
                        cmpsTabButton
                        theme="a"
                        [selected]="ctx.selected"
                        (click)="ctx.select()"
                    >
                        <span cmpsTabButtonLabel>{{
                            _i18n._11096_RECENTLY_CLOSED_FOR_THIS_PERFORMER
                                | translate
                        }}</span>
                    </button>
                </ng-template>
                <ng-template
                    cmpsTabLabel
                    [tabRefId]="_NavigationTabRefs.ACTIVE_FOR_TEAM"
                    let-ctx
                >
                    <button
                        cmpsTabButton
                        theme="a"
                        [selected]="ctx.selected"
                        (click)="ctx.select()"
                    >
                        <span cmpsTabButtonLabel>{{
                            _i18n._11097_ACTIVE_FOR_YOUR_TEAM | translate
                        }}</span>
                    </button>
                </ng-template>
                <ng-template
                    cmpsTabLabel
                    [tabRefId]="_NavigationTabRefs.RECENTLY_CLOSED_FOR_TEAM"
                    let-ctx
                >
                    <button
                        cmpsTabButton
                        theme="a"
                        [selected]="ctx.selected"
                        (click)="ctx.select()"
                    >
                        <span cmpsTabButtonLabel>{{
                            _i18n._11098_RECENTLY_CLOSED_FOR_YOUR_TEAM
                                | translate
                        }}</span>
                    </button>
                </ng-template>
            </cmps-tabset-label-wrapper>
            <cmps-tabset-content-wrapper>
                <ng-template
                    cmpsTabContent
                    [tabRefId]="_NavigationTabRefs.ACTIVE_FOR_PERFORMER"
                >
                    <div class="grid-wrapper">
                        <active-for-performer-grid
                            [gridData]="activeForPerformerGrid"
                            (selectRow)="
                                _selectGridRow(
                                    _NavigationTabRefs.ACTIVE_FOR_PERFORMER,
                                    $event
                                )
                            "
                            (sortGrid)="
                                _sortGrid(
                                    _NavigationTabRefs.ACTIVE_FOR_PERFORMER,
                                    $event
                                )
                            "
                        ></active-for-performer-grid>
                    </div>
                </ng-template>
                <ng-template
                    cmpsTabContent
                    [tabRefId]="
                        _NavigationTabRefs.RECENTLY_CLOSED_FOR_PERFORMER
                    "
                >
                    <div class="grid-wrapper">
                        <closed-for-performer-grid
                            [gridData]="closedForPerformerGrid"
                            (selectRow)="
                                _selectGridRow(
                                    _NavigationTabRefs.RECENTLY_CLOSED_FOR_PERFORMER,
                                    $event
                                )
                            "
                            (sortGrid)="
                                _sortGrid(
                                    _NavigationTabRefs.RECENTLY_CLOSED_FOR_PERFORMER,
                                    $event
                                )
                            "
                        >
                        </closed-for-performer-grid>
                    </div>
                </ng-template>
                <ng-template
                    cmpsTabContent
                    [tabRefId]="_NavigationTabRefs.ACTIVE_FOR_TEAM"
                >
                    <div class="grid-wrapper">
                        <active-for-team-grid
                            [gridData]="activeForTeamGrid"
                            (selectRow)="
                                _selectGridRow(
                                    _NavigationTabRefs.ACTIVE_FOR_TEAM,
                                    $event
                                )
                            "
                            (sortGrid)="
                                _sortGrid(
                                    _NavigationTabRefs.ACTIVE_FOR_TEAM,
                                    $event
                                )
                            "
                        ></active-for-team-grid>
                    </div>
                </ng-template>
                <ng-template
                    cmpsTabContent
                    [tabRefId]="_NavigationTabRefs.RECENTLY_CLOSED_FOR_TEAM"
                >
                    <div class="grid-wrapper">
                        <closed-for-team-grid
                            [gridData]="closedForTeamGrid"
                            (selectRow)="
                                _selectGridRow(
                                    _NavigationTabRefs.RECENTLY_CLOSED_FOR_TEAM,
                                    $event
                                )
                            "
                            (sortGrid)="
                                _sortGrid(
                                    _NavigationTabRefs.RECENTLY_CLOSED_FOR_TEAM,
                                    $event
                                )
                            "
                        >
                        </closed-for-team-grid>
                    </div>
                </ng-template>
            </cmps-tabset-content-wrapper>
        </cmps-tabset>
    </div>
    <div
        *ngIf="!pending"
        class="card-footer"
    >
        <button
            cmpsButton
            (click)="_selectFocus()"
            [disabled]="!_selectedFocus"
        >
            <span cmpsButtonLabel>
                {{ _i18n._11103_SELECT_FOCUS | translate }}
            </span>
        </button>
    </div>
</div>
